export var MessageTemplateButtonTypes;
(function (MessageTemplateButtonTypes) {
    MessageTemplateButtonTypes["DEFAULT"] = "default";
    MessageTemplateButtonTypes["QUICK_REPLY"] = "quick_reply";
    MessageTemplateButtonTypes["CALL_TO_ACTION"] = "call_to_action";
})(MessageTemplateButtonTypes || (MessageTemplateButtonTypes = {}));
export var CallToActionTypes;
(function (CallToActionTypes) {
    CallToActionTypes["PHONE_NUMBER"] = "phone_number";
    CallToActionTypes["URL"] = "url";
})(CallToActionTypes || (CallToActionTypes = {}));
export const HTTP_URL_REGEX = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;
export const verifyActionsValueLength = (item, isUrl) => isUrl ? item?.length > 2000 : item?.length > 20;
export const getTrackedButtonType = (buttonType, buttons) => buttonType === MessageTemplateButtonTypes.CALL_TO_ACTION
    ? buttons.map(button => button.type).join(', ')
    : buttonType;
